// extracted by mini-css-extract-plugin
export var Hero = "style-module--Hero--0d3ee";
export var ImagePrefix = "style-module--ImagePrefix--594b5";
export var Intro = "style-module--Intro--d98c9";
export var SlideshowImage = "style-module--SlideshowImage--2b73b";
export var SocialLinks = "style-module--SocialLinks--91b9a";
export var Subtitle = "style-module--Subtitle--b2a2d";
export var Title = "style-module--Title--32b63";
export var TitleImage = "style-module--TitleImage--8036f";
export var WelcomeImage = "style-module--WelcomeImage--baf04";